import { Card, Col, Row } from "react-bootstrap";
import IconButton from '../../../components/ui/icon-btn';
import { Typography } from "@amway/react-components";
import { mdiKeyboardBackspace } from "@mdi/js";
import { useEffect } from "react";
import { Translation, TranslationFormData } from "../../../resources/translations/translations-model";
import useTranslationList from "../../../resources/translations/translations-hook";
import TranslationsToolFormComponent from "../translations-form";

type Props = {
    rule: Translation;
    onBackClick: VoidFunction;
    user: string | undefined
}

export default function TranslationsToolEdit({ rule, onBackClick, user }: Props) {
    const { updateTranslationStatus, updateTranslation } = useTranslationList()

    useEffect(() => {
        if (updateTranslationStatus.success) {
            onBackClick()
        }
    }, [onBackClick, updateTranslationStatus.success])

    const handleUpdate = (data: TranslationFormData) => {
        updateTranslation(rule.id!, {
            ...data,
            id: rule.id,
            createdBy: rule.createdBy!,
            createdDt: rule.createdDt ?? new Date().toISOString(),
            updatedBy: user!
        });
    };

    return (
        <Card className="translation-tool-edit">
            <Card.Body>
                <Row>
                    <Col>
                        <IconButton mdiIconPath={mdiKeyboardBackspace} onClick={onBackClick} title="Back" size="27px">
                            Back to Translations List
                        </IconButton>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Typography variant="heading">
                            Edit Translation
                        </Typography>
                        <Typography weight="bold" color="text-gray" className="mt-3">
                            Edit the fields below.
                        </Typography>
                    </Col>
                </Row>
                <Row>
                    <TranslationsToolFormComponent
                        initial={{
                            locale: rule.locale,
                            translateFrom: rule.translateFrom,
                            translateTo: rule.translateTo,
                        }}
                        submitLabel="UPDATE"
                        onSubmit={handleUpdate}
                    />
                </Row>
            </Card.Body>
        </Card>
    )
}